var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31",
    "data-name": "Group 31",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.767,
    height: 19.981,
    viewBox: "0 0 19.767 19.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1253.378,998h-8.812a5.492,5.492,0,0,0-5.477,5.536v8.907a5.493,5.493,0,0,0,5.477,5.537h8.812a5.493,5.493,0,0,0,5.478-5.537v-8.907A5.492,5.492,0,0,0,1253.378,998Zm3.692,14.444a3.73,3.73,0,0,1-3.692,3.732h-8.812a3.73,3.73,0,0,1-3.691-3.732v-8.907a3.73,3.73,0,0,1,3.691-3.731h8.812a3.73,3.73,0,0,1,3.692,3.731v8.907Z",
    transform: "translate(-1239.089 -998.004)",
    fill: "#840094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1248.972,1002.767a5.136,5.136,0,0,0-5.12,5.227,5.122,5.122,0,1,0,5.12-5.227Zm0,8.632a3.4,3.4,0,1,1,3.335-3.4A3.444,3.444,0,0,1,1248.972,1011.4Z",
    transform: "translate(-1239.089 -998.004)",
    fill: "#840094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1254.212,1001.338a1.229,1.229,0,1,0,.953.357A1.355,1.355,0,0,0,1254.212,1001.338Z",
    transform: "translate(-1239.089 -997.962)",
    fill: "#840094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgIcon);
export default __webpack_public_path__ + "static/media/ig-icon.f934e504d2bd0a442aa65d53b11c7db4.svg";
export { ForwardRef as ReactComponent };